const { supabaseWeather } = require('Services/supabaseClient')

export function fetchSearchResults(query) {
  return supabaseWeather.from('cww_locations').select('*').ilike('location_name', `%${query}%`).order('location_name', { ascending: true }).limit(10)
}

export function fetchUserSavedLocations(userId) {
  return supabaseWeather.from('cww_user_locations').select('*').eq('user_id', userId).order('created_at', { ascending: false })
}

export async function deleteLocationForUser(userId, locationId) {
  return await supabaseWeather.from('cww_user_locations').delete().eq('user_id', userId).eq('location_id', locationId)
}

export async function saveLocationForUser(userId, location) {
  return await supabaseWeather.from('cww_user_locations').upsert([{ user_id: userId, location_id: location.id, location_name: location.location_name, latitude: location.latitude, longitude: location.longitude, country_code: location.country_code, state: location.state, region: location.region, country_name: location.country_name, zone: location.zone, country_id: location.country_id }], { onConflict: 'user_id,location_id' })
}

export async function fetchOtherLocations(userId, locationIds) {
  return await supabaseWeather.from('cww_user_locations').select('*').eq('user_id', userId).in('location_id', locationIds)
}

export async function fetchLocations(locationIds) {
  return await supabaseWeather
    .from('cww_locations')
    .select(
      `
          id,
          timezone,
          zone,
          country_code,
          country_id,
          country_name,
          latitude,
          longitude,
          region,
          state
        `
    )
    .in('id', locationIds)
}

export async function fetchWeatherData(location) {
  return await supabaseWeather
    .from('cww_weather_data')
    .select('*')
    .eq('location_id', location?.location_id || location.id)
    .order('updated_at', { ascending: false })
    .limit(1)
    .single()
}
